import { Bar , mixins } from 'vue-chartjs';

const { reactiveProp } = mixins

export default {
  extends: Bar ,
  mixins: [reactiveProp],
  props: ['chartData', 'options'],  
  mounted () {
     this.$data._plugins.push({
       afterDraw: function (chart) {
         const chartInstance = chart;
         const ctx = chartInstance.ctx;        
         ctx.textAlign = 'center';
         ctx.z = 999;
         ctx.fillStyle = "rgba(0, 0, 0, 1)";
         ctx.textBaseline = 'bottom';
         var fontSize = 12;
         var fontStyle = 'bold';
         var fontFamily = 'Helvetica Neue';
         ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);
        
         chart.chart.chart.data.datasets.forEach(function (dataset, i) {
             var meta = chartInstance.controller.getDatasetMeta(i);
             Chart.helpers.each(meta.data.forEach(function(bar, index) {
              var data = dataset.data[index];
              var barHeight = bar._model.y - bar._model.base;
              var centerY = bar._model.base + barHeight/2

               if (data > 0){
                 if(isNaN(centerY)){
                  ctx.fillText(data, bar._model.x, bar._model.y+20);
                 }else{
                  ctx.fillText(data,bar._model.x, bar._model.y);
                 }
                 
                //ctx.fillText(data, bar._model.x, bar._model.y + 10);
                //ctx.fillText('(100%)', bar._model.x, bar._model.y - 5);
               }else{
                ctx.fillText(data,bar._model.x, bar._model.y);
               }               
             }),this);
         });
       }
     });

    this.renderChart(this.chartData, this.options);
  }
}